import Interweave from "interweave"
import React from "react"

import { iArticleContentData } from "../../types"
import { ContentSeparator } from "../Utils/ContentSeparator"
import withTranslations from "./withTranslations"

export const ContentHeadingView: React.FC<{ text: string }> = ({ text }) => (
  <h1 className="text-2xl text-site-blue-dark">
    <Interweave content={text} />
  </h1>
)

const ContentHeading: React.FC<{
  content: iArticleContentData
  defaultLanguage: string | undefined
}> = ({ content, defaultLanguage }) => {
  if (!content) return null
  const HeadingWithTranslations = withTranslations(
    content.default,
    content.translations,
    defaultLanguage,
    ContentHeadingView
  )
  return (
    <>
      <HeadingWithTranslations />
      <ContentSeparator />
    </>
  )
}

export default ContentHeading
